import commonFn from '@/commons/commonFunction';
import {MSConstant} from '@/commons/wildcards';
// import Utility from '@/commons/utility';
// import authService from '@/auth/authService';
import ToastPlugin from 'vue-toast-notification';
import {vfmPlugin} from 'vue-final-modal';
import VueClickAway from 'vue3-click-away';
import 'vue-toast-notification/dist/theme-sugar.css';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

import {initSocket} from '@/sockets/socket.js';
export function pluginInstall(app) {
  app.config.globalProperties.$ms = app.config.globalProperties.$ms ? app.config.globalProperties.$ms : {};
  app.config.globalProperties.$ms.commonFn = commonFn;
  app.config.globalProperties.$ms.constant = MSConstant;

  app.use(vfmPlugin);
  app.use(ToastPlugin, window._toastConfig || {});
  app.use(VueClickAway);
  app.use(FloatingVue);
  initSocket(app);
  // DNThang - 13.04.2020: Thực hiện nhúng vào toàn bộ các element hàm lấy ra VueInstance tránh dùng __Vue__ không chuẩn tắc
  app.mixin({
    mounted() {
      const me = this;
      if (me.$el && !me.$el.getVueInstance) {
        me.$el.getVueInstance = () => {
          return this;
        };
      }
    },
  });
}
